module.exports = __webpack_public_path__ + "img/Thumb_SnowDay.4d8ed8d7.jpg";